export {CustomTableComponent} from "./lib/components/custom-table/custom-table.component";
export * from './lib/admin-vendor-shared.module';
